<template>
  <div>
    <!--<el-form-item :label="$t('默认值')">
       <el-input v-model="data.default"
                :placeholder="$t('请输入')"></el-input>
    </el-form-item>-->
    <el-divider>{{$t('私有属性')}}</el-divider>
    <el-form-item :label="$t('高度')">
      <el-input-number v-model="data.height"
        controls-position="right"
        :placeholder="$t('请输入')"></el-input-number>
    </el-form-item>
    <el-form-item :label="$t('显示菜单')">
      <el-switch v-model="data.menubar" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('显示状态栏')">
      <el-switch v-model="data.statusbar" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('改变大小')">
      <el-switch v-model="data.resize" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('工具栏模式')">
      <l-select v-model="data.toolbar_mode" :options="[
        {label: '下滑抽屉', value: 'sliding'},
        {label: '悬浮抽屉', value: 'floating'},
        {label: '横向滚动', value: 'scrolling'},
        {label: '自动换行', value: 'wrap'},
      ]"></l-select>
    </el-form-item>
    <el-form-item :label="$t('是否必填')">
        <el-switch v-model="data.required" ></el-switch>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "config-neweditor",
  props: ['data'],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

